import { mapActions, mapGetters } from "vuex";

export const userMixin = {
  computed: {
    ...mapGetters({
      users: "user/list/items",
      user: "user/current/retrieved",
      errorUserCreate: "user/create/error",
      errorUserUpdate: "user/update/error",
    }),
  },
  methods: {
    ...mapActions({
      getUsers: "user/list/getItems",
      userRetrieve: "user/current/retrieve",
      userCreate: "user/create/create",
      userUpdate: "user/update/update",
      resetUser: "user/current/reset",
    }),
  },
};
